var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('EXCMMessageForm',{attrs:{"handle-submit":_vm.onSendForm,"handle-update-field":_vm.updateField,"values":_vm.item,"id-sender-type":_vm.idSenderType,"recipient":_vm.recipient,"errors":_vm.violations}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }